import { createAction } from 'typesafe-actions';

import { HostPlatform } from 'store/host-info/consts';

/**
 * The host answered. `platform` is null when the payload carried none -- which the native shell's
 * payload never does, so `isNativeApp` is carried separately rather than derived from its absence.
 */
export const setHostInfo = createAction('SET_HOST_INFO')<{
  platform: HostPlatform | null;
  isNativeApp: boolean;
}>();
